import React, { useState } from 'react';

interface StarterPromptProps {
  onGenerate?: (prompt: string) => void;
}

const StarterPrompt: React.FC<StarterPromptProps> = ({ onGenerate }) => {
  const [prompt, setPrompt] = useState('');

  const handleGenerate = (e: React.FormEvent) => {
    e.preventDefault();
    if (onGenerate) {
      onGenerate(prompt);
    } else {
      // Placeholder: replace with actual logic
      alert(`Generate for: ${prompt}`);
    }
  };

  return (
    <form className="starter-prompt-form" onSubmit={handleGenerate}>
      <div className="starter-prompt-input-wrapper">
        <textarea
          className="starter-prompt-input"
          placeholder="Enter your prompt..."
          value={prompt}
          onChange={e => setPrompt(e.target.value)}
          required
          rows={4}
        />
      </div>
      <button className="starter-prompt-generate" type="submit">
        Start Learning
      </button>
    </form>
  );
};

export default StarterPrompt; 